import constants from '../constants';

export function selectBranches(branches) {
    return {
        payload: {
            selectedBranches: branches,
        },
        type: constants.SELECTED_BRANCHES,
    };
}
